import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../../layout/Box';
import './styles.scss';
import UploadBox from './UploadBox';
import { getUploadResumeState, getAuthState } from '../../../selectors';
import { toggleUploadDispatchBox } from 'signoxe/actions';

import { connect } from 'react-redux';

import _ from 'lodash';


class Resumable extends React.Component {

    constructor(props){
        super(props);
        this.state = {
          uploads: {},
          runningCount: 0
        }
    }

    decreaseCount(){this.setState({runningCount:this.state.runningCount - 1})}

    increaseCount(){this.setState({runningCount: this.state.runningCount + 1})}

    componentDidUpdate(prevProps, prevState, snapshot){
      if (this.props.startState.start){
        const { start, data } = this.props.startState;
        this.props.toggleUploadDispatchBox()
        switch (data.type){
          case 'resume':
            this.setState({uploads: {...this.state.uploads, [data.id]: data}})
          case 'fresh':
            this.setState({uploads: {...this.state.uploads, [data.id]: {...data.choice, ...data}}})
          default:
            return
        }
      }
    }


    render() {
      const { visible, startState, authState } = this.props;
      const { uploads } = this.state
      return (
        <div className={`${visible ? '' : 'd-none'}`}>
          {uploads && _.map(uploads, (value, key)=>{
            return (
              <UploadBox
                increase={this.increaseCount.bind(this)}
                decrease={this.decreaseCount.bind(this)}
                data={value}
                auth={authState}
              />
            )
          })}
        </div>
      )
    }
}

Resumable.propTypes = {
  resumableUploads: PropTypes.array
};

const mapStateToProps = (state) => {
  return{
    startState: getUploadResumeState(state),
    authState: getAuthState(state)
  }
}

export default connect(mapStateToProps, {
  toggleUploadDispatchBox
})(Resumable)


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ResumableBox/index.js